import React, { useCallback, useState, useEffect, ChangeEvent } from 'react';
import { FiCamera, FiSave, FiEdit2, FiXCircle, FiTrash } from 'react-icons/fi';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../hooks/auth';
import upload from '../../assets/upload.png';
import api from '../../services/api';
import { Loading } from '../../components/Loading';
import ModalConexao from '../../components/ModalConexao';
import {
  Container,
  ContainerButton,
  ContainerForm,
  ButtonBorder,
  ContainerHorizontal,
} from './styles';
import DrawerApp from '../../components/Drawer';

interface FeedGet {
  ID: number;
  TITULO: string;
  IMAGEM: string;
}

const setores = [
  { valor: 'Marketing', id: 16, NivelAcesso: 1 },
  { valor: 'Todos', id: 15, NivelAcesso: 1 },
];

const UploadPost: React.FC = () => {
  const { userAcesso } = useAuth();
  const history = useHistory();
  const [feeds, setFeeds] = useState<FeedGet[]>([]);
  const [idFeed, setIdFeed] = useState<number>(0);
  const [edit, setEdit] = useState(true);
  const [urlAntiga, setUrlAntiga] = useState('');
  const [fileData, setFileData] = useState<FileList>();
  const [titulo, setTitulo] = useState('');
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);

  interface Acesso {
    CPF: number;
    EMAIL: string;
    ID: number;
    NivelACesso: number;
    Nome: string;
    Nome_NivelAcesso: string;
    Setor: string;
    SetorID: number;
    idUsuario: number;
  }

  // const [setorAcesso, setSetorAcesso] = useState<Acesso>({
  //   CPF: 0,
  //   EMAIL: '',
  //   ID: 0,
  //   NivelACesso: 0,
  //   Nome: '',
  //   Nome_NivelAcesso: '',
  //   Setor: '',
  //   SetorID: 0,
  //   idUsuario: 0,
  // });
  // const nivelDeAcessoDaTela = {
  //   setor: 17,
  //   nomeSetor: 'Ponto Eletrônico',
  //   nivel: 4,
  //   NomeNivel: 'Analista',
  // }; // ANALISTA

  useEffect(() => {
    let semAcesso = true;
    let access;
    userAcesso.forEach((user) => {
      access = setores.filter(
        (s) => s.id === user.SetorID && user.NivelACesso >= s.NivelAcesso,
      );
      if (access.length > 0) {
        semAcesso = false;
      }
    });
    if (semAcesso) {
      history.push('/dashboard');
      Swal.fire({
        icon: 'info',
        text: 'Seu nível de acesso não tem permissão para acessar essa página!',
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      });
    } else {
      setLoading(true);
      api
        .get(`feedNoticias`)
        .then((data) => {
          setFeeds(data.data);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
          if (navigator.onLine) {
            Swal.fire({
              icon: 'info',
              text: 'Erro ao carregar dados, por favor atualize a página!',
              showClass: {
                popup: 'animate__animated animate__fadeInDown',
              },
              hideClass: {
                popup: 'animate__animated animate__fadeOutUp',
              },
            });
          }
        });
    }
  }, [history, refresh, userAcesso]);

  const handleImagemFeed = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      try {
        if (e.target.files) {
          setFileData(e.target.files);
          // console.log(e.target.files);
          const url = URL.createObjectURL(e.target.files[0]);
          feeds.map((feed: FeedGet) => {
            if (feed.ID === idFeed) {
              setUrlAntiga(feed.IMAGEM);
              // eslint-disable-next-line no-param-reassign
              feed.IMAGEM = url;
              // setImagemData(data);
            }
            return feed;
          });
          setFeeds(feeds);
        }
      } catch (err) {
        Swal.fire({
          icon: 'info',
          text: 'Erro ao carregar dados, tente novamente!',
          showClass: {
            popup: 'animate__animated animate__fadeInDown',
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp',
          },
        });
      }
    },
    [feeds, idFeed],
  );

  const handleCancelEdit = useCallback(() => {
    try {
      if (urlAntiga !== '') {
        feeds.map((feed: FeedGet) => {
          if (feed.ID === idFeed) {
            setUrlAntiga(feed.IMAGEM);
            // eslint-disable-next-line no-param-reassign
            feed.IMAGEM = urlAntiga;
            setUrlAntiga('');
          }
          return feed;
        });
        setFeeds(feeds);
      }
    } catch (err) {
      Swal.fire({
        icon: 'info',
        text: 'Erro ao carregar dados, tente novamente!',
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      });
    }
  }, [urlAntiga, feeds, idFeed]);

  const handleSalvar = useCallback(async () => {
    try {
      if (fileData) {
        setLoading(true);
        const data = new FormData();
        data.append('feed', fileData[0]);
        data.append('titulo', titulo);
        data.append('seq', idFeed.toString());
        await api
          .post('feedNoticias/insertFeed', data)
          .then(() => {
            Swal.fire({
              icon: 'success',
              text: 'Feed salvo com sucesso!',
              showClass: {
                popup: 'animate__animated animate__fadeInDown',
              },
              hideClass: {
                popup: 'animate__animated animate__fadeOutUp',
              },
            });
            setFileData(undefined);
            setEdit(true);
            setTitulo('');
            setLoading(false);
          })
          .catch(() => {
            Swal.fire({
              icon: 'error',
              text: 'Erro ao Salvar feed!',
              showClass: {
                popup: 'animate__animated animate__fadeInDown',
              },
              hideClass: {
                popup: 'animate__animated animate__fadeOutUp',
              },
            });
            setLoading(false);
          });
      } else {
        Swal.fire({
          icon: 'info',
          text: 'Adicione uma Imagem para Salvar!',
          showClass: {
            popup: 'animate__animated animate__fadeInDown',
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp',
          },
        });
      }
    } catch (err) {
      Swal.fire({
        icon: 'error',
        text: 'Erro ao Salvar, tente novamente!',
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      });
      setLoading(false);
    }
  }, [fileData, titulo, idFeed]);

  const handleDeletar = useCallback(
    async (id: number) => {
      try {
        setLoading(true);
        await api
          .delete('feedNoticias/deleteFeed', { data: { seq: id } })
          .then(() => {
            Swal.fire({
              icon: 'success',
              text: 'Feed deletado com sucesso!',
              showClass: {
                popup: 'animate__animated animate__fadeInDown',
              },
              hideClass: {
                popup: 'animate__animated animate__fadeOutUp',
              },
            });
            setEdit(true);
            setTitulo('');
            setIdFeed(0);
            setRefresh(!refresh);
            setLoading(false);
          })
          .catch(() => {
            Swal.fire({
              icon: 'error',
              text: 'Erro ao deletar feed!',
              showClass: {
                popup: 'animate__animated animate__fadeInDown',
              },
              hideClass: {
                popup: 'animate__animated animate__fadeOutUp',
              },
            });
            setLoading(false);
          });
      } catch (err) {
        Swal.fire({
          icon: 'error',
          text: 'Erro ao deletar, tente novamente!',
          showClass: {
            popup: 'animate__animated animate__fadeInDown',
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp',
          },
        });
        setLoading(false);
      }
    },
    [refresh],
  );

  const handleCertezaDelete = useCallback(
    (id: number) => {
      Swal.fire({
        text: 'Tem certeza que deseja Apagar?',
        // text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim',
      }).then((result) => {
        if (result.isConfirmed) {
          handleDeletar(id);
        }
      });
    },
    [handleDeletar],
  );

  return (
    <Container>
      <ModalConexao />
      <DrawerApp />
      {/* <Header /> */}
      <ContainerHorizontal>
        {feeds.map((feed: FeedGet) => (
          <ContainerForm key={feed.ID}>
            <div>
              <h1>Feed {feed.ID}</h1>
              <img src={feed.IMAGEM ? feed.IMAGEM : upload} alt="Imagem Feed" />
              <div>
                <input
                  type="text"
                  accept="image/*"
                  placeholder={feed.TITULO}
                  onChange={(e) => setTitulo(e.target.value)}
                />
              </div>
            </div>
            <ContainerButton>
              {!edit && idFeed === feed.ID && (
                <div>
                  <ButtonBorder>
                    <label htmlFor={feed.ID.toString()}>
                      <FiCamera />
                      <input
                        type="file"
                        id={feed.ID.toString()}
                        onChange={(e) => handleImagemFeed(e)}
                      />
                    </label>
                  </ButtonBorder>
                  <ButtonBorder
                    onClick={() => {
                      if (titulo === '') {
                        setTitulo(feed.TITULO);
                      }
                      setIdFeed(feed.ID);
                      handleSalvar();
                    }}
                  >
                    <FiSave />
                  </ButtonBorder>
                  <ButtonBorder
                    onClick={() => {
                      setEdit(true);
                      setIdFeed(feed.ID);
                      handleCancelEdit();
                    }}
                  >
                    <FiXCircle />
                  </ButtonBorder>
                </div>
              )}
              {edit && (
                <div>
                  <ButtonBorder
                    onClick={() => {
                      setEdit(false);
                      setIdFeed(feed.ID);
                    }}
                  >
                    <FiEdit2 />
                  </ButtonBorder>
                  <ButtonBorder
                    onClick={() => {
                      handleCertezaDelete(feed.ID);
                    }}
                  >
                    <FiTrash />
                  </ButtonBorder>
                </div>
              )}
            </ContainerButton>
          </ContainerForm>
        ))}
      </ContainerHorizontal>
      {loading && <Loading />}
    </Container>
  );
};

export default UploadPost;
